import { useState, useEffect } from 'react';

const COOKIE_KEY = 'sydneypt_onboarded';

export function OnboardingModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (document.cookie.includes(COOKIE_KEY)) return;
    setOpen(true);
  }, []);

  function dismiss() {
    document.cookie = `${COOKIE_KEY}=1;max-age=31536000;path=/`;
    setOpen(false);
  }

  if (!open) return null;

  return (
    <div className="onboarding-overlay" onClick={dismiss}>
      <div className="onboarding-modal" onClick={(e) => e.stopPropagation()}>
        <h2>🚌 Welcome to SydneyPT!</h2>

        <div className="onboarding-step">
          <h3>🏠 Home</h3>
          <p>Add your favourite stops and stations to see live departures. Filter by train, bus, ferry or metro using the pill buttons.</p>
        </div>

        <div className="onboarding-step">
          <h3>🧭 Plan</h3>
          <p>Search for an origin and destination to plan a trip. After getting results, tap 💾 <strong>Save Trip</strong> to access it quickly from the Home tab.</p>
        </div>

        <div className="onboarding-step">
          <h3>🗺 Map</h3>
          <p>See live vehicle positions on the map. Toggle which modes to show. Tap a vehicle to see its trip details and delay.</p>
        </div>

        <div className="onboarding-step">
          <h3>⚠ Alerts</h3>
          <p>View active service disruptions and alerts from Transport for NSW.</p>
        </div>

        <button className="onboarding-dismiss" onClick={dismiss}>Got it!</button>
      </div>
    </div>
  );
}
